import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "optionsPanel",
    "documentBoundingBoxes",
    "documentSearchQuery",
    "documentSearchResultCount",
    "resultsContainer"
  ]

  SELECTED_PAGE_CLASSES = ["border-2", "border-orange", "border-solid"]
  SELECTED_BOUNDING_BOX_CLASSES = ["border-2", "border-medium-gray", "bg-orange", "opacity-50"]

  initialize() {
    this.selectedBoundingBoxes = []
  }

  connect() {
  }

  toggleOptions() {
    this.optionsPanelTarget.classList.toggle("hidden");
  }

  searchDocument() {
    if (this.documentSearchQueryTarget.value.length > 0) {
      var newSelectedBoundingBoxes = []
      var boundingBoxes = document.querySelectorAll("[data-target-dom-id]")
      
      for (var i = 0; i < boundingBoxes.length; i++) {
        var val = boundingBoxes[i].dataset.value
        val = val.toLowerCase()
        var query = this.documentSearchQueryTarget.value.toLowerCase()
        if (val.includes(query)) {
          newSelectedBoundingBoxes.push(boundingBoxes[i])
        }
      }

      this.markSelected(newSelectedBoundingBoxes)

    } else {
      this.markSelected([])
      this.resultsContainerTarget.scrollTop = 0
    }
  }
  
  markSelected(selectedBoundingBoxes) {
    // deselect all currently selected bounding boxes and pages
    for (var i = 0; i < this.selectedBoundingBoxes.length; i++) {
      for (var j = 0; j < this.SELECTED_BOUNDING_BOX_CLASSES.length; j++) {
        this.selectedBoundingBoxes[i].classList.remove(this.SELECTED_BOUNDING_BOX_CLASSES[j])  
      }

      var pageElm = document.querySelector("#" + this.selectedBoundingBoxes[i].dataset.targetDomId)
      for (var j = 0; j < this.SELECTED_PAGE_CLASSES.length; j++) {
        pageElm.classList.remove(this.SELECTED_PAGE_CLASSES[j])
      }
    }

    // select new bounding boxes and pages
    this.selectedBoundingBoxes = []

    for (var i = 0; i < selectedBoundingBoxes.length; i++) {
      var pageElm = document.querySelector("#" + selectedBoundingBoxes[i].dataset.targetDomId)
      if (i === 0) {
        pageElm.scrollIntoView()
      }

      for (var j = 0; j < this.SELECTED_BOUNDING_BOX_CLASSES.length; j++) {
        selectedBoundingBoxes[i].classList.add(this.SELECTED_BOUNDING_BOX_CLASSES[j])
      }
      
      for (var j = 0; j < this.SELECTED_PAGE_CLASSES.length; j++) {
        pageElm.classList.add(this.SELECTED_PAGE_CLASSES[j])
      }
      
      this.selectedBoundingBoxes.push(selectedBoundingBoxes[i])
    }

    this.documentSearchResultCountTarget.innerText = this.selectedBoundingBoxes.length
  }
}